import { parseQuickAdd } from '../lib/parser/index.js';
import { formatRrule } from '../lib/rrule-format.js';

const PRESETS: Array<{ label: string; phrase: string }> = [
  { label: 'No repeat', phrase: '' },
  { label: 'Daily', phrase: 'every day' },
  { label: 'Weekdays', phrase: 'every weekday' },
  { label: 'Weekly', phrase: 'every week' },
  { label: 'Monthly', phrase: 'every month' },
  { label: 'Yearly', phrase: 'every year' },
];

function replaceRruleToken(
  text: string,
  phrase: string,
  today: string
): string {
  const parsed = parseQuickAdd(text, today);
  const tok = parsed.tokens.find((t) => t.type === 'rrule');
  if (tok) {
    const before = text.slice(0, tok.start).replace(/\s+$/, '');
    const after = text.slice(tok.end).replace(/^\s+/, '');
    const parts = [before, phrase, after].filter(Boolean);
    return parts.join(' ').trim();
  }
  if (!phrase) return text;
  return text ? `${text.trim()} ${phrase}` : phrase;
}

/**
 * La répétition d'une tâche en cours de saisie : un <select> natif (`.saisie` du kit). Choisir
 * un préréglage réécrit la phrase dans le texte (« every week »), c'est le texte qui fait foi.
 * Une règle tapée à la main qui n'est aucun préréglage reste affichée, sous son libellé.
 */
export function RepeatDropdown({
  value,
  rrule,
  today,
  onChange,
}: {
  value: string;
  rrule: string | null;
  today: string;
  onChange: (next: string) => void;
}): React.ReactElement {
  const current = rrule ? formatRrule(rrule) : 'No repeat';
  const preset = PRESETS.find((p) => p.label.toLowerCase() === current?.toLowerCase());

  return (
    <select
      className="saisie"
      aria-label="Repeat"
      value={preset ? preset.label : '__custom__'}
      onChange={(e) => {
        const p = PRESETS.find((x) => x.label === e.target.value);
        if (p) onChange(replaceRruleToken(value, p.phrase, today));
      }}
    >
      {!preset && <option value="__custom__">{current}</option>}
      {PRESETS.map((p) => (
        <option key={p.label} value={p.label}>
          {p.label}
        </option>
      ))}
    </select>
  );
}
